import React from 'react';
import PropTypes from 'prop-types';
import { DangerButton, SecondaryButton } from '../../../../../CommonComponents/Button';
import Modal from '../../../../../CommonComponents/Modal';
import { ModalFooter, ModalWrapper } from './StopMonitoringModalStyles';

const StopMonitoringModal = ({ children, onConfirm, onRequestClose, isConfirmDisabled }) => {
  return (
    <Modal isOpen>
      <ModalWrapper>
        <h2>{children}</h2>
        <ModalFooter>
          <DangerButton onClick={onConfirm} disabled={isConfirmDisabled}>
            Confirm
          </DangerButton>
          <SecondaryButton type="submit" onClick={onRequestClose}>
            Cancel
          </SecondaryButton>
        </ModalFooter>
      </ModalWrapper>
    </Modal>
  );
};

StopMonitoringModal.defaultProps = {
  isConfirmDisabled: false,
};

StopMonitoringModal.propTypes = {
  children: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  isConfirmDisabled: PropTypes.bool,
};

export default StopMonitoringModal;
